export default __webpack_public_path__ + "static/kristian-freeman-fac7a709fba1a084c8c7621abada1715.png";